// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, "span.posted[data-v-d9c272cc]{display:inline-block;margin-right:1em}#recentPosts h2[data-v-d9c272cc]{margin-bottom:0}.postTags[data-v-d9c272cc]{margin-bottom:1em}", ""]);
// Exports
module.exports = exports;
